import * as React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import c from 'classnames';

import { Clickable } from '../../types';
import { colors } from '../../styles';

import { Icon, IconName } from '../icons';

export interface Props extends Clickable {
  className?: string;
  icon?: IconName;
  open?: boolean;
  allowToggling?: boolean;
}
interface State {
  open: boolean;
}

class Heading extends React.Component<Props, State> {
  public static defaultProps: Props = {
    icon: 'empty',
    onClick: () => null,
    open: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = { open: props.open };
  }

  public componentWillReceiveProps(nextProps) {
    this.setState({ open: nextProps.open });
  }

  public render() {
    const { allowToggling, className, icon } = this.props;
    const { open } = this.state;

    return (
      <div className={c(className, { open })} onClick={this.handleToggleClick}>
        <Icon baseColor={colors.grey900} icon={icon} size="md" />
        <span className="label">{this.props.children}</span>
        {allowToggling && (
          <Icon
            baseColor={colors.black}
            icon={open ? 'caretUp' : 'caretDown'}
            size="xs"
          />
        )}
        <div className="shadow" />
      </div>
    );
  }

  private handleToggleClick = e => {
    this.setState(prevState => ({ open: !prevState.open }));
    this.props.onClick(e);
  };
}

export default styled(Heading)`
  align-items: center;
  cursor: default;
  display: flex;
  flex-shrink: 0;
  padding: 1.5em;
  position: relative;

  &.open .shadow {
    display: block;

    &:after {
      visibility: visible;
    }
  }

  .label {
    flex-grow: 1;
    margin: 0 1.5em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 70%;
  }

  :hover {
    background-color: ${colors.grey50};
  }

  .shadow {
    bottom: -1.5em;
    display: none;
    left: 0;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: -1.5em;

    &:before,
    &:after {
      bottom: 1.5em;
      content: '';
      left: -3em;
      position: absolute;
      right: -3em;
      top: 1.5em;
      visibility: hidden;
    }

    &:before {
      box-shadow: 0 -1.5em 1.5em -1.5em ${colors.grey200};
    }

    &:after {
      box-shadow: 0 1.5em 1.5em -1.5em ${colors.grey200};
    }
`;
